import { useTranslation } from "../i18n";
import BundlesAdmin from "../components/BundlesAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

// Admin › Warehouse › Bundles (plan: feat-bundles.md). One channel SKU
// that stands for N units of one or more Portal SKUs. Definitions only —
// a bundle SKU is never a product or stock; order ingest rewrites a
// bundle line into its component lines.
const AdminBundles = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="bundles_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "bundles_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("bundles_admin_hint")}</p>
                <BundlesAdmin />
            </div>
        </div>
    );
};

export default AdminBundles;
